import React from 'react'

const PharmacyStoreIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="consumerIcon">
      <path
        d="M2.8 4.66667V3.73333C2.58431 3.73346 2.37533 3.80829 2.20858 3.94509C2.04183 4.0819 1.92761 4.27223 1.88533 4.48373L2.8 4.66667ZM25.2 4.66667L26.1147 4.48373C26.0724 4.27223 25.9582 4.0819 25.7914 3.94509C25.6247 3.80829 25.4157 3.73346 25.2 3.73333V4.66667ZM27.0667 14V14.9333C27.2047 14.9333 27.341 14.9026 27.4657 14.8434C27.5905 14.7843 27.7005 14.6983 27.788 14.5915C27.8755 14.4848 27.9382 14.3599 27.9717 14.226C28.0051 14.0921 28.0084 13.9524 27.9813 13.8171L27.0667 14ZM0.933333 14L0.0186667 13.8171C-0.00838759 13.9524 -0.00508288 14.0921 0.0283427 14.226C0.0617683 14.3599 0.124483 14.4848 0.211967 14.5915C0.299452 14.6983 0.409529 14.7843 0.534268 14.8434C0.659007 14.9026 0.795302 14.9333 0.933333 14.9333V14ZM6.53333 19.6H5.6V20.5333H6.53333V19.6ZM21.4667 19.6V20.5333H22.4V19.6H21.4667ZM0 28H28V26.1333H0V28ZM1.86667 14V27.0667H3.73333V14H1.86667ZM24.2667 14V27.0667H26.1333V14H24.2667ZM2.8 5.6H25.2V3.73333H2.8V5.6ZM24.2853 4.8496L26.152 14.1829L27.9813 13.8171L26.1147 4.48373L24.2853 4.8496ZM27.0667 13.0667H0.933333V14.9333H27.0667V13.0667ZM1.848 14.1829L3.71467 4.8496L1.88533 4.48373L0.0186667 13.8171L1.848 14.1829ZM1.86667 1.86667H26.1333V0H1.86667V1.86667ZM5.6 14V19.6H7.46667V14H5.6ZM6.53333 20.5333H21.4667V18.6667H6.53333V20.5333ZM22.4 19.6V14H20.5333V19.6H22.4Z"
        fill="#EF8658"
      />
    </g>
  </svg>
)

export default PharmacyStoreIcon
